import type { QuestionQuota } from "@/pages/QuestionsPage/ui/QuestionSearch/questionsQuotaApi";
import type { PlanWallet } from "../api/supPlanApi";
import { searchOpen } from "./planGate";

/**
 * Кошелёк пакетов в форме, которую понимают оба экрана поиска (прежний
 * QuestionSearchGated и СУП v2): открытый поиск — один пакет «на срок» до даты
 * поиска, закрытый поиск или «Продолжим завтра» — пусто; `viewed` — с
 * сервера (открытое раньше открывается бесплатно и после конца срока).
 *
 * Число в пакете нигде не показывается: в режиме пакетов вместо счётчика —
 * дата («до 29.08.2027»). Оно только держит ворота «есть чем платить»
 * открытыми, пока открыт поиск; считает сервер.
 */
export const PLAN_OPEN_UNITS = 999;

export const PLAN_PACKAGE_ID = "plan-search";

export const planQuota = (w: PlanWallet, now: number = Date.now()): QuestionQuota => {
    const open = searchOpen(w, now) && !w.dailyCapped;
    return {
        version: 2,
        packages: open
            ? [
                  {
                      id: PLAN_PACKAGE_ID,
                      count: PLAN_OPEN_UNITS,
                      initialCount: PLAN_OPEN_UNITS,
                      expiresAt: w.search?.until || new Date(now).toISOString(),
                      source: "purchase",
                      createdAt: new Date(now).toISOString(),
                  },
              ]
            : [],
        viewed: [...(w.viewed || [])],
    };
};
